import React from 'react';
import { TableRow, TableCell, IconButton } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import useAppStore from 'store/useAppStore';

export default function SortableTableRow({ id, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      {...attributes}
      sx={{
        '&:hover': {
          backgroundColor: isDragging ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
        },
      }}
    >
      {children}
      {!readOnly && (
        <TableCell sx={{ p: 1, width: '40px' }}>
          <IconButton
            size="small"
            color="default"
            title="拖拽排序"
            {...listeners}
            sx={{
              cursor: 'grab',
              '&:active': {
                cursor: 'grabbing',
              },
            }}
          >
            <DragIndicator fontSize="small" />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
}
